import { useContext, useEffect, useReducer, useState } from "react";
import { AnimalSponsorshipAppContext, AnimalSponsorshipState } from "../Context/AnimalSponsorshipAppContext";
import { AnimalItem } from "../Data/AnimalItems";
import AnimalSponsorshipFetch from "../Utilities/AnimalSponsorshipFetch";

const pageSize = 12;

export type AnimalSponsorshipsState = {
    selectedSpecies: string[]
    selectedStatus?: string
    search?: string
    animals: AnimalItem[]
    displayedAnimals: AnimalItem[]
    page: number
    loaded?: boolean
};

type AnimalSponsorshipsAction = { type: "selectedSpecies", data: string[] }
    | { type: "selectedStatus", data?: string }
    | { type: "search", data?: string }
    | { type: "animals", data: AnimalItem[] }
    | { type: "displayedAnimals", data: AnimalItem[] }
    | { type: "page", data: number }

const initialState: IAnimalSponsorshipsContext = {
    selectedSpecies: [],
    animals: [],
    displayedAnimals: [],
    page: 1
}

export interface IAnimalSponsorshipsContext extends AnimalSponsorshipsState {
}

function reducer(oldState: AnimalSponsorshipsState = initialState, action: AnimalSponsorshipsAction) {
    const state = { ...oldState }
    const { type, data } = action
    switch (type) {
        case "selectedSpecies":
            state.selectedSpecies = data;
            break;
        case "selectedStatus":
            if(!data || data.length == 0){
                state.selectedStatus = undefined;
            } else {
                state.selectedStatus = data;
            }
            break;
        case "search":
            state.search = data;
            break;
        case "animals":
            state.animals = data;
            state.loaded = true;
            state.page = 1
            break;
        case "displayedAnimals":
            state.displayedAnimals = data;
            break;
        case "page":
            state.page = data;
            break;
    }
    return state
}

let debounceTimout: NodeJS.Timeout | null;

export default () => {
    let {
        loading,
        error,
        conservation,
        species,
        dictionary
    } = useContext<AnimalSponsorshipState>(AnimalSponsorshipAppContext)

    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(() => {
        AnimalSponsorshipFetch.fetchAnimals(window.baseApiUrl, window.apiCulture, null, null, null)
            .then(x => dispatch({ type: "animals", data: x }));
    }, []);

    useEffect(() => {
        state.loaded && AnimalSponsorshipFetch.fetchAnimals(window.baseApiUrl
            , window.apiCulture
            , state.search ?? null
            , state.selectedStatus ?? null
            , state.selectedSpecies.length > 0 ? state.selectedSpecies : null)
        .then(x => dispatch({ type: "animals", data: x }));
    }, [state.selectedSpecies, state.selectedStatus, state.search])

    useEffect(() => {
        dispatch({ type: "displayedAnimals", data: state.animals.slice(0, state.page * pageSize) })
    }, [state.page, state.animals])

    const toggleSpecies = (key: string | null) => {
        console.debug(key);
        if (key && state.selectedSpecies.indexOf(key) > -1) {
            state.selectedSpecies = state.selectedSpecies.filter(x => x != key)
        } else {
            key && state.selectedSpecies.push(key)
        }
        dispatch({ type: "selectedSpecies", data: [...state.selectedSpecies] })
    }

    const pageIncrement = () => {
        dispatch({ type: "page", data: state.page + 1 })
    }

    const setSelectedSpecies = (species: string[]) => {
        dispatch({ type: 'selectedSpecies', data: species })
    }

    const setSelectedStatus = (status?: string) => {
        dispatch({ type: "selectedStatus", data: status })
    }

    const search = (search?: string) => {
        //Is the ID already set
        if (debounceTimout != null) {
            //Clear the timeout for the id
            clearTimeout(debounceTimout);
            //Destroy the id
            debounceTimout = null;
        }
        
        //↓ The new id
        debounceTimout = setTimeout(() => {
            //Dispatch the search
            dispatch({ type: "search", data: search })
        }, 1000);
    }


    return {
        species
        , toggleSpecies
        , pageIncrement
        , selectedSpecies: state.selectedSpecies
        , setSelectedSpecies
        , selectedStatus: state.selectedStatus
        , setSelectedStatus
        , seachText: state.search
        , search
        , conservation
        , displayedAnimals: state.displayedAnimals
        , loading
        , error
        , showLoadMore: state.animals.length > state.displayedAnimals.length
        , dictionary
    }
}